<template>
  <b-col cols="12">
    <b-card>
      <div slot="header">
        <div class="float-left" v-text="surveyName" />
        <div class="float-right" v-text="surveyGroupNumber" />
      </div>

      <b-tabs>
        <b-tab active>
          <template v-slot:title>{{
            $lang.surveyLang.survey_group_info
          }}</template>
          <GroupInfoTab @updateItem="updateItem" @close="close" />
        </b-tab>
        <b-tab :lazy="true">
          <template v-slot:title>
            {{ $lang.surveyLang.survey_group_azmoon }}
          </template>
          <AzmoonTab :term="pathOr(null, ['term'], item)" />
        </b-tab>
        <b-tab :lazy="true">
          <template v-slot:title>
            {{ $lang.surveyLang.survey_group_parvandeh }}
          </template>
          <ParvandehTab />
        </b-tab>
        <b-tab :lazy="true">
          <template v-slot:title>
            {{ $lang.surveyGroupParvandehByTerm }}
          </template>
          <ParvandehByTermTab />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-col>
</template>

<script>
import { pathOr } from "ramda";
import GroupInfoTab from "./edit-survey-tabs/groupInfoTab.vue";
import AzmoonTab from "./edit-survey-tabs/azmoonTab.vue";
import ParvandehTab from "./edit-survey-tabs/parvandehTab.vue";
import ParvandehByTermTab from "./edit-survey-tabs/ParvandehByTermTab.vue";

export default {
  components: {
    GroupInfoTab,
    AzmoonTab,
    ParvandehTab,
    ParvandehByTermTab,
  },
  data() {
    return {
      item: null,
    };
  },
  computed: {
    surveyName() {
      return `${this.$lang.surveyLang.edit_survey_group} (${pathOr(
        "",
        ["name"],
        this.item
      )})`;
    },
    surveyGroupNumber() {
      return `${this.$lang.surveyLang.survey_group_number}: ${pathOr(
        "",
        ["survey_group_number"],
        this.item
      )}`;
    },
  },
  methods: {
    pathOr,
    close() {
      window.close();
    },
    updateItem(data) {
      this.item = data;
    },
  },
};
</script>
